import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.starts-with.js";
import { getSalaryDetail, setSalaryStatus } from '@/services/salary';
import config from '@/pathConfig';
export default {
  name: 'ImportDetail',
  data: function data() {
    return {
      statusFilter: '',
      query: {
        keyword: ''
      },
      loading: false,
      dataList: [],
      recordInfo: {
        importType: 1,
        salaryMonth: '',
        operatorName: '',
        importTime: '',
        totalCount: 0,
        successCount: 0,
        failCount: 0
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  computed: {
    columns: function columns() {
      var _this = this;
      var baseColumns = [{
        title: '序号',
        key: 'serial',
        width: 60,
        fixed: 'left',
        customRender: function customRender(text, record, index) {
          return (_this.pagination.current - 1) * _this.pagination.pageSize + index + 1;
        }
      }, {
        title: '姓名',
        dataIndex: 'name',
        width: 80,
        fixed: 'left'
      }, {
        title: '身份证号码',
        dataIndex: 'idCard',
        fixed: 'left',
        width: 160
      }, {
        title: '发放月份',
        dataIndex: 'salaryMonth',
        fixed: 'left',
        width: 100
      }, {
        title: '学部',
        dataIndex: 'department',
        width: 120
      }];
      var dynamicColumns = [];
      if (this.recordInfo.importType === 1) {
        // 教职工模板
        dynamicColumns = [{
          title: '固定薪酬',
          children: [{
            title: '档案工资',
            dataIndex: 'baseSalary',
            width: 80
          }, {
            title: '基础性绩效',
            dataIndex: 'basePerformance',
            width: 80
          }]
        }, {
          title: '考核薪酬',
          children: [{
            title: '奖励性绩效',
            dataIndex: 'rewardPerformance',
            width: 80
          }, {
            title: '加班工资',
            dataIndex: 'overtimePay',
            width: 80
          }, {
            title: '其他',
            dataIndex: 'otherPay',
            width: 80
          }]
        }, {
          title: '绩效薪酬',
          children: [{
            title: '年终奖',
            dataIndex: 'yearEndBonus',
            width: 80
          }, {
            title: '春季学期目标奖',
            dataIndex: 'springBonus',
            width: 90
          }, {
            title: '秋季学期目标奖',
            dataIndex: 'autumnBonus',
            width: 90
          }]
        }, {
          title: '校长基金',
          dataIndex: 'principalFund',
          width: 80
        }];
      } else {
        // 工勤人员模板
        dynamicColumns = [{
          title: '固定薪酬',
          dataIndex: 'fixedPay',
          width: 100
        }, {
          title: '考核薪酬',
          dataIndex: 'assessmentPay',
          width: 100
        }, {
          title: '绩效薪酬',
          dataIndex: 'performancePay',
          width: 100
        }];
      }
      var actionColumns = [{
        title: '应发合计',
        dataIndex: 'totalAmount',
        width: 100
      }, {
        title: '备注',
        dataIndex: 'remark'
      }, {
        title: '状态',
        dataIndex: 'status',
        fixed: 'right',
        width: 80,
        scopedSlots: {
          customRender: 'status'
        }
      }, {
        title: '操作',
        key: 'action',
        width: 100,
        fixed: 'right',
        scopedSlots: {
          customRender: 'action'
        }
      }];
      return [].concat(baseColumns, _toConsumableArray(dynamicColumns), actionColumns);
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var _this2 = this;
      this.loading = true;
      var params = _objectSpread({
        recordId: this.$route.query.id,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }, this.query);
      if (this.statusFilter !== '') {
        params.status = this.statusFilter;
      }
      getSalaryDetail(params).then(function (res) {
        // 兼容处理：支持 { data: { list, ... } } 和 { list, ... } 两种结构
        var result = res.data.data || res.data;
        if (result && result.list) {
          _this2.dataList = result.list;
          _this2.recordInfo = result.record || result || {};
          _this2.pagination.total = result.total || result.list.length;
        } else {
          _this2.dataList = result.list || result || [];
          _this2.pagination.total = result.total || _this2.dataList.length;
        }
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleTableChange: function handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.fetchData();
    },
    downloadSourceFile: function downloadSourceFile() {
      var filePath = this.recordInfo.filePath || this.recordInfo.filepath;
      if (!filePath) return this.$message.warning('暂无源文件');
      var url = filePath.startsWith('http') ? filePath : "".concat(config.baseUrl).concat(filePath);
      var link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      link.download = filePath.split('/').pop();
      link.click();
    },
    toggleStatus: function toggleStatus(record) {
      var _this3 = this;
      var newStatus = record.status === 1 ? 0 : 1;
      setSalaryStatus({
        id: record.id,
        status: newStatus,
        type: 'detail'
      }).then(function () {
        _this3.$message.success('操作成功');
        _this3.fetchData();
      });
    }
  }
};